import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Icon, IconButton, Stack, Typography } from '@mui/material';

import { palette, spaces } from '../../assets/styles/themes/tokens';
import getMuiIcon from '../../utils/getMuiIcon';

interface SectionHeaderWithActionsProps {
  title: string;
  isEditMode: boolean;
  onEdit: () => void;
  toggleConfirmDialog: () => void;
  onSave: () => void;
}

const EditableSectionHeader = ({
  title,
  isEditMode,
  onEdit,
  toggleConfirmDialog,
  onSave
}: SectionHeaderWithActionsProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography
        variant='h6'
        color={palette.text.primary}
        sx={{ py: spaces.md }}
      >
        {title}
      </Typography>

      {!isEditMode ? (
        <IconButton
          data-testid='edit-profile-button'
          onClick={onEdit}
          size='small'
          color='secondary'
        >
          <Icon
            component={getMuiIcon('editPen')}
            sx={{ width: 32, height: 32 }}
          />
        </IconButton>
      ) : (
        <Stack direction='row' spacing={spaces.xs}>
          <Button
            variant='outlined'
            color='primary'
            size='medium'
            onClick={toggleConfirmDialog}
          >
            {t('Cancel')}
          </Button>
          <Button
            variant='contained'
            color='primary'
            size='medium'
            onClick={onSave}
          >
            {t('Save')}
          </Button>
        </Stack>
      )}
    </Box>
  );
};

export default EditableSectionHeader;
